import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/seven_seven_promo_rectangle.jpg",
  style: {"max-width":"100% !important","height":"auto !important"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
}